import { useMemo } from 'react';
import { isHexColor, readableTextOn, withAlpha } from './brandColors';

const ACCENT_DEFAULTS = {
    accent: '#A424F4',
    accentMuted: 'rgba(164,36,244,0.25)',
    accentDisabled: 'rgba(134,36,244,0.4)',
    onAccent: '#FFFFFF',
};

const LIGHT = {
    ...ACCENT_DEFAULTS,
    pageBg: '#F5F5F5',
    chatBg: '#FFFFFF',
    headerBg: '#FFFFFF',
    headerBorder: '#E8E8E8',
    botBubble: '#EFEFEF',
    userBubble: '#8700DB',
    inputBg: '#F0F0F0',
    inputAreaBg: '#FFFFFF',
    textPrimary: '#1A1A1A',
    textSecondary: '#666666',
    dateText: '#999999',
    borderColor: '#E8E8E8',
    avatarBg: '#8700DB',
    iconColor: '#666666',
    attachmentBg: '#FFFFFF',
    attachmentHover: '#F5F5F5',
};

const DARK = {
    ...ACCENT_DEFAULTS,
    pageBg: '#161616',
    chatBg: '#191919',
    headerBg: '#1F1F1F',
    headerBorder: '#313131',
    botBubble: '#3F3F3F',
    userBubble: '#8700DB',
    inputBg: '#2D2D2F',
    inputAreaBg: '#191919',
    textPrimary: '#FFFFFF',
    textSecondary: '#959595',
    dateText: '#727272',
    borderColor: '#313131',
    avatarBg: '#8700DB',
    iconColor: '#959595',
    attachmentBg: '#2D2D2F',
    attachmentHover: '#3F3F3F',
};

const NEUTRAL_ACCENT = { light: '#C4C4C4', dark: '#5A5A5A' };

// While branding loads, accents stay neutral so the default purple never flashes.
const useChatTheme = (isDark, primaryColor, isLoading = false) => useMemo(() => {
    const base = isDark ? DARK : LIGHT;
    if (isLoading) {
        const n = NEUTRAL_ACCENT[isDark ? 'dark' : 'light'];
        return { ...base, userBubble: n, avatarBg: n, accent: n, accentMuted: withAlpha(n, 0.4), accentDisabled: withAlpha(n, 0.4) };
    }
    if (!isHexColor(primaryColor)) return base;
    return {
        ...base,
        userBubble: primaryColor,
        avatarBg: primaryColor,
        accent: primaryColor,
        accentMuted: withAlpha(primaryColor, 0.25),
        accentDisabled: withAlpha(primaryColor, 0.4),
        onAccent: readableTextOn(primaryColor),
    };
}, [isDark, primaryColor, isLoading]);

export default useChatTheme;
